module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAABRklEQVR42p1RPUvEQBCNqKiVnf4D7cTK1t9gpyKoheLsXnZ2ZnMGrjqxsbE5UEghfpQp/BMiFmJnZaWNCKLdYRlnIBzeJcLpwiPz9d7uvER1x3hOAPkdHH8ax2fGh7VomNNutyeFuCGkZ4vUjGNaMi6gCN2Bo6u405n4lYy4P2+QHgHpCXxyrDdL/ibETITHRDiXuFsUxUiFnKbptDQLg7zzs05EU2X9WnONdb2KgA4IzutelmXZOCAfASYLSZLMSPyB2JrtH3D8pfsP45OsdgtEy70C+BAD0qtBvhyEdbRSfW04UWN7Bd0LXNi1LmwOwvjm4qCAxdACDId9AqJ6A54uhoFFftjzdK9xnuejkWWeK93dUtiYU4MU6gDIpzor2NbZ3i/VoiZlswtIL3XQfgNpveKsNsSwVf1G/zlqopLFoIO/cr8B5f/eSoKjVjEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/c-workinjuries_1x.png
// module id = 2290
// module chunks = 0